
















import CompanyEdit from '@/views/system/organization/company/unit/edit.vue';
import CompanyIndex from '@/views/system/organization/company/unit/index.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { CompanyEdit, CompanyIndex },
})
export default class Company extends Vue {
  rowId = ''; // 传递到编辑页面和角色分配页面的 该行的id
  showFlag = 1; // 展示主页组件或者编辑和新增组件 :1 是主页组件 2 是编辑 3 是新增下级 4 是新增
  row = ''; // 主页组件传递过来的需要修改的一行数据。
  /**
   * @todo 后期需要优化的部分
   * @desc 自定义事件，得到要修改一行的数据。
   * @param state - 模板状态 1-开始状态 2-结束状态
   * @returns 返回值描述
   */
  getRow(row: string) {
    this.row = row;
  }
}
